import { render, staticRenderFns } from "./ButtonSaveData.vue?vue&type=template&id=3dcb0a94&scoped=true&"
import script from "./ButtonSaveData.vue?vue&type=script&lang=js&"
export * from "./ButtonSaveData.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSaveData.vue?vue&type=style&index=0&id=3dcb0a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb0a94",
  null
  
)

export default component.exports